import React, { useEffect } from "react";
import { ConfigProvider } from "antd";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import faIR from "antd/es/locale/fa_IR";
import "./App.css";
import Layout from "Layout";
import Routes from "Routes";
import { AuthProvider, useAuthDispatch } from "Contexts/Auth";
import { getAuthStorage, clearAuthStorage } from "Utils/authUtils";
import Login from "Pages/Login";
import Logout from "Pages/Logout/Logout";
import auth from "Api/auth";
import axios from "axios";

axios.defaults.baseURL = "/api";
function App() {
  const dispatch = useAuthDispatch();
  auth.useIsLogin();
  useEffect(() => {
    const storedState = getAuthStorage();
    if (storedState.isLoggedIn) {
      dispatch({
        type: "loggedIn",
        data: {
          name: storedState.name,
          role: storedState.role,
        },
      });
    }
    axios.interceptors.response.use(
      function (response) {
        return response;
      },
      function (error) {
        if (error?.response?.status === 401) {
          dispatch({ type: "loggedOut" });
          clearAuthStorage();
        }
        return Promise.reject(error);
      }
    );
  }, []);
  return (
    <ConfigProvider direction="rtl" locale={faIR}>
      <BrowserRouter>
        <Switch>
          <Route path="/login" component={Login} />
          <Route path="/logout" component={Logout} />
          <Layout>
            <Routes />
          </Layout>
        </Switch>
      </BrowserRouter>
    </ConfigProvider>
  );
}

export default () => (
  <AuthProvider {...getAuthStorage()}>
    <App />
  </AuthProvider>
);
